import { IconGift } from '@tabler/icons-react'
import axios from 'axios'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { Alert } from 'src/components/Alert/Alert'
import { Button } from 'src/components/Button/Button'
import { config } from 'src/config'
import { useLocale } from 'src/contexts/LocaleContext'
import { useCartQuery } from 'src/hooks/useCartQuery'

export const GiftSubscriptionClaimButton = () => {
  const { language } = useLocale()
  const { query, asPath, push } = useRouter()
  const { data: cart } = useCartQuery()

  const [errorMesssage, setErrorMesssage] = useState('')

  const giftId = query.giftId as string | undefined
  const loginSuccessful = query.login_successful === 'true'
  const customerId = cart?.buyerIdentity.customer?.id

  useEffect(() => {
    if (loginSuccessful && customerId && giftId) {
      createGiftSession()
    }
  }, [loginSuccessful, customerId, giftId])

  const claimGiftClick = () => {
    if (!giftId) {
      return
    }

    const returnUrl = `${process.env.NEXT_PUBLIC_HOSTNAME}${asPath}${encodeURIComponent('&login_successful=true')}`

    push(`${process.env.NEXT_PUBLIC_SHOPIFY_CHECKOUT_URL}/account/login?checkout_url=${returnUrl}`)
  }

  const createGiftSession = async () => {
    try {
      const { data } = await axios.post(
        `${config.serviceHost}/api/gift-subscription/v2/gift-claim-session`,
        {
          customerId,
          giftId,
        },
        {
          headers: {
            'Accept-Language': language,
          },
        },
      )

      // redirect to chargebee claim portal
      push(data.url)
    } catch (error) {
      if (error.response?.status === 400) {
        setErrorMesssage('Fehler: Dieses Geschenkabo wurde bereits eingelöst.')
      } else {
        setErrorMesssage('Fehler: Das Geschenkabo konnte nicht eingelöst werden. Bitte wende dich an unseren Support.')
      }
    }
  }

  return (
    <div>
      <Button onClick={claimGiftClick} startIcon={<IconGift />} fullWidthMobile>
        Jetzt dein Geschenkabo einlösen
      </Button>

      {errorMesssage && <Alert variant="error">{errorMesssage}</Alert>}
    </div>
  )
}
